import React,{useState} from 'react';
import Talk from 'talkjs';
import { Layout} from 'antd';
import axios from "axios"; 
import { useSelector } from "react-redux";
import { Link,useNavigate } from "react-router-dom";
import AdminSideBar from './AdminSideBar';
const { Content } = Layout;

class AdminPanel extends React.Component {
  constructor(props) {
    super(props)
    this.talkjsContainer = React.createRef();
  }
  componentDidMount() {    
    Talk.ready.then(() => {
      var me = new Talk.User({
        id: parseInt(Math.random()*500000).toString(),
        name: "Alice",
        email: "demo@talkjs.com",
        photoUrl: "https://demo.talkjs.com/img/alice.jpg",
        welcomeMessage: "Hey there! How are you? :-)",
        role: "booker"
      });
      
     const talkSession = new Talk.Session({
        appId: "tUzMLcrn",
        me: me
      });
      
      var other = new Talk.User({
        id: parseInt(Math.random()*500000).toString(),
        name: "HelpDesk",
        email: "demo@talkjs.com",
        photoUrl: "https://demo.talkjs.com/img/sebastian.jpg",
        welcomeMessage: "Hey, how can We help you?",
        role: "booker"
      });

      var conversation = talkSession.getOrCreateConversation(Talk.oneOnOneId(me, other));
      conversation.setParticipant(me);
      conversation.setParticipant(other);
      
      var inbox = talkSession.createInbox({selected: conversation});
      inbox.mount(this.talkjsContainer.current);
    });
  }
  render(){
    return (
      <Content style={{marginTop:'5%'}}>  
      <Layout hasSider >
        <AdminSideBar props='1'/>
      <Layout className="site-layout" >
        <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
        <div ref={this.talkjsContainer} className="chatbox-container" 
        style={{marginTop:'3%',marginBottom:'1%',minHeight:'350px',width:'100%',height:'450px'}}></div>
        </Content>
      </Layout>
      <div id='responseDiv'></div>
    </Layout>
    </Content>
    )

  }
}

export default AdminPanel